import { render, staticRenderFns } from "./CardResumeProgram.vue?vue&type=template&id=f16cf42a"
import script from "./CardResumeProgram.vue?vue&type=script&lang=js"
export * from "./CardResumeProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports